import { FetchOptions } from 'bernie-core';
import { getOperationName } from '@apollo/client/utilities';
import { print } from 'graphql/language/printer';

import {
  FlightsQueryState,
  FlightsShoppingPwaFlightSearchResultsFlightsSearch,
  FlightsShoppingPwaFlightSearchResultsFlightsSearchDocument
} from '__generated__/api/';

export function clientInfoHeader(headers, appName, region): Headers {
  return {
    ...headers,
    'Client-Info': `${appName},latest,${region || 'external'}`
  };
}

export const getFlightsSearchLoadedHeaders = (
  options: FetchOptions,
  variables: FlightsShoppingPwaFlightSearchResultsFlightsSearch.Variables,
  appName: string,
  region: string,
  pageId: string
): RequestInit => {
  const {
    headers: { connection },
    context: { deviceId }
  } = options.request;

  const flightsSearchLoadedHeaders = {
    'Content-Type': 'application/json',
    credentials: 'same-origin',
    Connection: connection,
    'Device-User-Agent-ID': deviceId,
    'x-page-id': pageId
  };

  const headers = clientInfoHeader(flightsSearchLoadedHeaders, appName, region);

  const reqBody = {
    operationName: getOperationName(FlightsShoppingPwaFlightSearchResultsFlightsSearchDocument),
    query: print(FlightsShoppingPwaFlightSearchResultsFlightsSearchDocument),
    variables: {
      ...variables,
      queryState: FlightsQueryState.LOADED
    }
  };

  return {
    method: 'POST',
    headers,
    cache: 'no-cache',
    body: JSON.stringify(reqBody)
  };
};
